import React from 'react';
import PropTypes from 'prop-types';
import { ModalHeader as BootstrapModalHeader } from 'reactstrap';


// Bootstrap 5 renders an empty `.btn-close` button. The app styles the
// Bootstrap 4 close button (`.modal-header .close` with the "×" sign), so the
// old markup is rendered instead.
const ModalHeader = ({ toggle = undefined, closeAriaLabel = 'Close', ...rest }) => (
  <BootstrapModalHeader
    {...rest}
    toggle={toggle}
    close={toggle ? (
      <button
        type="button"
        className="close"
        aria-label={closeAriaLabel}
        onClick={toggle}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    ) : undefined}
  />
);

ModalHeader.propTypes = {
  toggle: PropTypes.func,
  closeAriaLabel: PropTypes.string,
};

export default ModalHeader;
